/* eslint-disable class-methods-use-this */
import CompositeFormField from './composite-field.js';
import AnalyticsHelper from '../../utils/analytics-helper';

export default class BankDetails extends CompositeFormField {
    constructor(parent, el) {
        super(parent, el);
        this.bankLookupBtn = this.el.querySelector('#bank-lookup');
        this.bankLookupLoader = this.el.querySelector('.bank_lookup_loader');
        this.responseSuccessMessage = this.el.querySelector('.bank_lookup_response_success');
        this.responseFailMessage = this.el.querySelector('.bank_lookup_response_failure');
        this.bankDetailsResponse = this.field('bankResponse');

        this.firstName = this.field('accountFirstName');
        this.lastName = this.field('accountLastName');
        this.sortCode = this.field('sortCode');
        this.accountNumber = this.field('accountNumber');
        this.requestFields = [this.firstName, this.lastName, this.sortCode, this.accountNumber];

        this.bind();
    }

    bind() {
        this.bankLookupBtn.addEventListener('click', (e) => {
            e.preventDefault();
            this.populateBankDetails(e);
        });
    }

    async populateBankDetails(event) {
        const valid = await this.form.valid(this.requestFields);
        if (valid) {
            this.bankLookupLoader.classList.remove('hide');
            const bankDetails = await this.getBankDetails();
            if (bankDetails?.branchData) {
                this.bankDetailsResponse.setContent(bankDetails);
                this.responseFailMessage.classList.add('hide');
                this.responseSuccessMessage.classList.remove('hide');
            } else {
                this.responseFailMessage.classList.remove('hide');
                this.responseSuccessMessage.classList.add('hide');
            }
            this.bankLookupLoader.classList.add('hide');
            AnalyticsHelper.push(event.target);
        }
    }

    async getBankDetails() {
        const data = new FormData();
        data.append('firstName', this.firstName?.inputs?.[0]?.el?.value);
        data.append('lastName', this.lastName?.inputs?.[0]?.el?.value);
        data.append('sortCode', this.sortCode?.inputs?.[0]?.el?.value);
        data.append('accountNumber', this.accountNumber?.inputs?.[0]?.el?.value);

        const request = fetch('/gateway/api/bank-details', {
            method: 'POST',
            body: data,
        });

        try {
            const response = await request;
            if (response.ok) {
                const result = await response.json();
                return result;
            }
        } catch (err) {
            console.error(err);
        }
    }

    static is(el) {
        return super.is(el) && el.classList.contains('form_field_bank_details');
    }
}
